import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FolderExplorerModal } from '@/explorer/FolderExplorerModal.organism';
import { useFluxPath } from '@/core/hooks/useFluxPath.hook';
import { HOME_SCREEN_TABS } from '@/main/app.constants';
import { errorToast } from '@/utilities/toast.utilities';
import { sqHomeScreenStore } from '@/core/core.stores';
import { Button } from '@seeqdev/qomponents';

interface CorporateDriveMessageProps {
  item?: any;
  itemId: string;
  itemName: string;
  onClose?: any;
  fetchInherited?: any;
  isAclModalLocationInHeader: boolean;
  aclModified?: any;
}

export const CorporateDriveMessage: React.FunctionComponent<CorporateDriveMessageProps> = ({
  item,
  onClose,
  aclModified,
  itemId,
  itemName,
  fetchInherited,
  isAclModalLocationInHeader,
}) => {
  const { t } = useTranslation();
  const currentTab = useFluxPath(sqHomeScreenStore, () => sqHomeScreenStore.currentTab);
  const handleFolderExplorerClose = () => {
    setShowFolderExplorerModal(false);
    if (!aclModified) {
      onClose();
    }
  };

  const [showFolderExplorerModal, setShowFolderExplorerModal] = useState(false);

  const moveCorporate = () => {
    if (sqHomeScreenStore.currentTab !== HOME_SCREEN_TABS.CORPORATE) {
      return setShowFolderExplorerModal(true);
    } else {
      return errorToast({
        messageKey: 'ITEM_ACL.ITEM_IN_CORPORATE_ERROR',
        messageParams: { item: itemName },
      });
    }
  };

  return (
    <>
      <div data-testid="corporateMessage" className="corporateMessage fakeTableRowDivider">
        {t('ITEM_ACL.CORPORATE_MESSAGE')}
        <Button
          testId="corporateMessageButton"
          onClick={moveCorporate}
          extraClassNames="ml15"
          label={t('ITEM_ACL.MOVE_CORPORATE')}
        />
        {showFolderExplorerModal && (
          <FolderExplorerModal
            onClose={handleFolderExplorerClose}
            item={item}
            currentTab={currentTab}
            corporateDriveMessage={true}
            itemId={itemId}
            itemName={itemName}
            isAclModalLocationInHeader={isAclModalLocationInHeader}
            aclModified={aclModified}
            fetchInherited={fetchInherited}
          />
        )}
      </div>
    </>
  );
};
